var React = require('react');

function MapMarkerEdit (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4a24 24 0 0 0 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm-43.17 283.15L106 288a9 9 0 0 1-10-9.95l4.8-42.83 85.54-85.54 48 48zm133.91-133.9l-28.26 28.26-48-48 28.26-28.26a18 18 0 0 1 25.41 0l22.57 22.57a18 18 0 0 1 .02 25.43z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M282.74 123.84l-22.57-22.57a18 18 0 0 0-25.41 0l-28.26 28.26 48 48 28.26-28.26a18 18 0 0 0-.02-25.43zM100.85 235.17L96.05 278a9 9 0 0 0 9.95 10l42.83-4.8 85.54-85.54-48-48z","className":"fa-primary","key":2})]);
}

MapMarkerEdit.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MapMarkerEdit;

MapMarkerEdit.default = MapMarkerEdit;
